import { AxiosRequestConfig } from 'axios'
import { getJWT } from '../localStorage'

export const standart: AxiosRequestConfig = {
    baseURL: 'https://caliente.app/api',
    headers: {
        Authorization: `Bearer ${getJWT()}`,
    },
}
